// eslint-disable-next-line import/prefer-default-export
// Rename Member to Teacher and Owner to Administrator when capabilities model is pushed in production and we are ready to delete membership model
export enum RoleType {
  Member = 'member',
  Owner = 'owner',
}
